var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.data || _vm.sheets),expression:"data || sheets"}],staticClass:"ml-2",attrs:{"color":"success","small":_vm.small,"loading":_vm.isLoading},on:{"click":_vm.exportToExcel}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiFileExcel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }